import type { ReactNode } from 'react';

interface MobileHeaderProps {
  onBack: () => void;
  title: string;
  rightContent?: ReactNode;
  children?: ReactNode;
}

export default function MobileHeader({ onBack, title, rightContent, children }: MobileHeaderProps) {
  return (
    <div className="sticky top-0 z-10 bg-static-white border-b border-[#E1DBD4] px-5 py-4">
      <div className="flex items-center justify-between">
        <button
          onClick={onBack}
          className="flex items-center gap-1 text-[#211C18] text-label1 font-medium cursor-pointer hover:opacity-70 transition-opacity"
        >
          <i className="ri-arrow-left-line text-lg"></i>
          뒤로
        </button>
        <h2 className="text-headline1 text-[#211C18]">{title}</h2>
        <div className="text-caption text-[#7A736C] min-w-[60px] text-right">
          {rightContent}
        </div>
      </div>
      {children}
    </div>
  );
}